import { notification } from "antd"

type NotifType = "success" | "error" | "info" | "warning"

type NotifPlacement = "topLeft" | "topRight" | "bottomLeft" | "bottomRight"

const useToastNotifications = () => {
  const [notifApi, toastContextHolder] = notification.useNotification()

  const openToastNotification = (
    type: NotifType,
    message: string,
    description: string | React.ReactNode,
    placement: NotifPlacement,
    options = {}
  ) => {
    notifApi[type]({
      message: message || type,
      description,
      placement: placement || "topRight",
      ...options,
    })

    return notifApi
  }

  return {
    openToastNotification,
    toastContextHolder,
  }
}

export default useToastNotifications
